export const REQUEST_MATCHES_INTERVAL = 60000
export const REQUEST_COMMENTARY_INTERVAL = 30000
